import React from 'react';

import { Svg } from '@lglp/components';

import styles from './SliderArrow.module.scss';

export enum ArrowOrientation {
  LEFT,
  RIGHT,
}

const SliderArrow: React.FC<SliderArrowProps> = (props) => {
  const { orientation = ArrowOrientation.RIGHT, className, ...rest } = props;

  let orientationClassName = styles.right;
  switch (orientation) {
    case ArrowOrientation.LEFT: {
      orientationClassName = styles.left;
      break;
    }
    case ArrowOrientation.RIGHT:
    default: {
      orientationClassName = styles.right;
      break;
    }
  }

  return (
    <Svg
      className={[styles.sliderArrow, orientationClassName, className]}
      viewBox="0 0 27.243 48.828"
      {...rest}
    >
      <path
        className="cls1"
        d="M9,52,32,29,9,6"
        transform="translate(-7.586 -4.586)"
      />
    </Svg>
  );
};

type SliderArrowProps = {
  orientation?: ArrowOrientation;
  className?: string;
};

export default SliderArrow;
